var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBelize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 10.5087 29.2332 5.6641 25.0179 2.7826L16 2.08691L6.98206 2.78254C2.76687 5.6641 0 10.5087 0 16C0 21.4914 2.76687 26.3359 6.98206 29.2174L16 29.913L25.0179 29.2174C29.2332 26.3359 32 21.4914 32 16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0183 2.78262C22.4505 1.02725 19.3456 0 16.0004 0C12.6552 0 9.55023 1.02725 6.98242 2.78262H25.0183Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98242 29.2173C9.55017 30.9727 12.6552 31.9999 16.0004 31.9999C19.3456 31.9999 22.4505 30.9727 25.0183 29.2173H6.98242Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 23.6523C20.2262 23.6523 23.6522 20.2263 23.6522 16.0001C23.6522 11.7739 20.2262 8.3479 16 8.3479C11.7738 8.3479 8.34781 11.7739 8.34781 16.0001C8.34781 20.2263 11.7738 23.6523 16 23.6523Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.2608C19.4578 22.2608 22.2609 19.4577 22.2609 15.9999C22.2609 12.5421 19.4578 9.73901 16 9.73901C12.5422 9.73901 9.73913 12.5421 9.73913 15.9999C9.73913 19.4577 12.5422 22.2608 16 22.2608Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.174C18.3052 20.174 20.1739 18.3053 20.1739 16.0001C20.1739 13.6949 18.3052 11.8262 16 11.8262C13.6948 11.8262 11.8261 13.6949 11.8261 16.0001C11.8261 18.3053 13.6948 20.174 16 20.174Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.9565L13.7391 16V17.7392L16 19.1305L18.2609 17.7392V16L16 14.9565Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7391 13.9131H18.2609V16H13.7391V13.9131Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBelize);
export default __webpack_public_path__ + "static/media/flag_belize.a86a7eacfd175cff3e035875e009bcd9.svg";
export { ForwardRef as ReactComponent };